var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCumeoClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM13 12V7H11V14H17V12H13Z",
    fill: "url(#grad-clock-cumeo)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-clock-cumeo",
    x1: 2,
    y1: 2,
    x2: 22,
    y2: 2.4
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106cf3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumeoClock);
export default __webpack_public_path__ + "static/media/cumeo-clock.34ace1d0b6a7ded235ab617ecc149696.svg";
export { ForwardRef as ReactComponent };